import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { Image, VideoControl } from '../../common/components';
import { useMobile } from '../../common/hooks/use-mobile';
import { isClickable, transformInterval, transformPageMargins } from '../../common/utils';
import { useDesignContext } from '../../design-provider';
export var Single = function Single(props) {
  var _props$imageAdList = props.imageAdList,
    imageAdList = _props$imageAdList === void 0 ? [] : _props$imageAdList,
    _props$imageSpacing = props.imageSpacing,
    imageSpacing = _props$imageSpacing === void 0 ? 0 : _props$imageSpacing,
    _props$pagePadding = props.pagePadding,
    pagePadding = _props$pagePadding === void 0 ? 0 : _props$pagePadding,
    _props$imageRadius = props.imageRadius,
    imageRadius = _props$imageRadius === void 0 ? 'rightAngle' : _props$imageRadius;
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  return _jsx("div", Object.assign({
    className: 'box-border grid grid-cols-1 w-full',
    style: {
      paddingLeft: transformPageMargins(pagePadding, mobile),
      paddingRight: transformPageMargins(pagePadding, mobile),
      gap: transformInterval(imageSpacing, mobile, 'photoAds')
    }
  }, {
    children: imageAdList.map(function (imageAd) {
      return _jsx("div", Object.assign({
        className: 'w-full'
      }, {
        children: imageAd.fileType === 'image' ? _jsx("a", Object.assign({
          className: classNames('block w-full h-full', {
            'cursor-pointer': isClickable(imageAd.target)
          }),
          href: designOnLink(imageAd.target)
        }, {
          children: _jsx(Image, {
            className: classNames('w-full', {
              'cursor-pointer': isClickable(imageAd.target)
            }),
            style: {
              borderRadius: imageRadius === 'rightAngle' ? undefined : '20px'
            },
            src: imageAd.fileValue
          })
        })) : _jsx(VideoControl, {
          className: 'w-full flex items-center justify-center',
          imageStyle: {
            borderRadius: imageRadius === 'rightAngle' ? undefined : '20px'
          },
          videoStyle: {
            borderRadius: imageRadius === 'rightAngle' ? undefined : '20px'
          },
          imageClassName: 'w-full',
          videoClassName: 'w-full',
          coverImage: imageAd.coverImage,
          fileValue: imageAd.fileValue
        })
      }), imageAd.id);
    })
  }));
};